

exports.__esModule = true;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CONTENT_KEY_MAP = {
    ADD_CARD: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddCard'
    },
    ADD_SHIPPING: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddShipping'
    },
    APPLY_PPC: {
        benefitsKey: 'passwordRecovery.stepUpApplyPPCBenefits',
        reasonKey: 'passwordRecovery.stepUpApplyPPC'
    },
    GENERIC: {
        benefitsKey: 'passwordRecovery.stepUpGenericBenefits',
        reasonKey: 'passwordRecovery.stepUpGeneric'
    },
    NEW_PHONE: {
        reasonKey: 'passwordRecovery.stepUpNewPhone'
    },
    NEED_US_ADDRESS: {
        reasonKey: 'passwordRecovery.stepUpNeedUSAddress'
    },
    CARD_EXPIRED: {
        reasonKey: 'passwordRecovery.stepUpCardExpired'
    },
    MERCHANT_NOT_ACCEPT_AMEX: {
        reasonKey: 'passwordRecovery.stepUpMerchantNotAcceptAmex'
    },
    NEED_CREDIT_CARD: {
        reasonKey: 'passwordRecovery.stepUpContigencyAddCard'
    },
    PAYER_AUTHENTICATION_REQUIRED: {
        reasonKey: 'passwordRecovery.stepUpNewAddress'
    },
    BILLING_AGREEMENTS: {
        reasonKey: 'passwordRecovery.stepUpBillingAgreements'
    },
    GENERIC_CONTINGENCY: {
        reasonKey: 'passwordRecovery.stepUpContigencyGeneric'
    }
};

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryLandingDirective', {
    tag: 'xo-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        },
        onContinue: {
            type: 'var'
        },
        onCancel: {
            type: 'var',
            required: false
        },
        reason: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.contingencyName = this.reason && _squid.$util.camelToCapsUnderscore(this.reason) || 'GENERIC';
            this.getReasonKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).reasonKey;
            };

            this.getBenefitsKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).benefitsKey;
            };
            this.onSubmit = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'quick_security_check',
                    to: 'process_quick_security_check'
                });
                _this.onContinue();
            };
        }
    }
});


_squid.$Component;

_squid.$util;

_logger.$logger;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/create-password/directive.js
 ** module id = 440
 ** module chunks = 1
 **/